// src/components/oficina/OperatorSwitcher.js
import React from "react";
import { User, RefreshCw } from "lucide-react";
import { useOperator } from "../../contexts/OperatorContext";

export default function OperatorSwitcher() {
  const { activeOperator, isSharedTerminal, setShowSelectModal, timeLeft, terminalType } = useOperator();

  if (!isSharedTerminal) return null;

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  const isLowTime = activeOperator && timeLeft < 30;

  return (
    <button
      onClick={() => setShowSelectModal(true)}
      className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-bold transition-all shadow-sm border ${
        activeOperator
          ? isLowTime
            ? "bg-red-50 text-red-700 border-red-200 animate-pulse"
            : "bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-100/80"
          : "bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100/80 animate-pulse"
      }`}
      title="Clique para alterar o operador ativo"
    >
      <User 
        size={14} 
        className={activeOperator ? (isLowTime ? "text-red-500" : "text-emerald-600") : "text-amber-600"} 
      />
      <span className="truncate max-w-[160px]">
        {activeOperator 
          ? `${terminalType} · ${activeOperator.nome} (${formatTime(timeLeft)})` 
          : "SEM OPERADOR"
        }
      </span>
      <RefreshCw size={12} className="opacity-60 shrink-0" />
    </button>
  );
}
